// selectedFile, title, category, price, description, link, location, contact 
interface PostData {
    selectedFile?: File | null;
    title?: string;
    description?: string;
    category?: string;
    link?: string;
}
    
interface FormValidation {
    postData: PostData;
    getAllPosts?: PostData[];
}

const postValidateSelectedFile = ({postData}: FormValidation) => {
    const errors: string[] = [];
    let isValid = false;

    if (!postData.selectedFile) {
        errors.push('file cannot be empty');
        isValid = false;
    }

    return { isValid, errors };
};

const postValidateTitle = ({postData}: FormValidation) => {
    const errors: string[] = [];
    let isValid  = false;
    const titleRegex = /^[A-Za-z0-9\s]+$/;

    // validate title
    if (!postData.title || postData.title.trim() === '') {
        errors.push('');
        isValid = false;
    } else if (postData.title.length < 2) {
        errors.push('title must be at least 2 letters');
        isValid = true;
    } else if (!titleRegex.test(postData.title)) {
        errors.push('title must contain only letters');
        isValid = true;
    } else if(postData.title.length > 100) {
        errors.push('title must not be more than 100 letters');
        isValid = true;
    }
    return { isValid, errors };
}
const postValidateDescription = ({postData}: FormValidation) => {
    const errors: string[] = [];
    let isValid  = false;
    const descriptionRegex = /^[A-Za-z0-9\s]+$/;

    // validate description
    if (!postData.description || postData.description.trim() === '') {
        errors.push('');
        isValid = false;
    } else if (postData.description.length < 2) {
        errors.push('description must be at least 2 letters');
        isValid = true;
    } else if (!descriptionRegex.test(postData.description)) {
        errors.push('description must contain only letters');
        isValid = true;
    } else if(postData.description.length > 200) {
        errors.push('description must not be more than 200 letters');
        isValid = true;
    }
    return { isValid, errors };
}

const postValidateCategory = ({postData}: FormValidation) => {
    const errors: string[] = [];
    let isValid = false;

    if (!postData.category || postData.category.trim() === '') {
        errors.push('category cannot be empty');
        isValid = false;
    }

    return { isValid, errors };
}

const postValidateLink = ({postData}: FormValidation) => {
    const errors: string[] = [];
    let isValid = false;

    if (!postData.link || postData.link.trim() === '') {
        errors.push('link cannot be empty');
        isValid = false;
    }

    return { isValid, errors };
};


export {
    postValidateSelectedFile,
    postValidateTitle,
    postValidateDescription,
    postValidateCategory,
    postValidateLink,
}